import http from '../config'

const frequent_contact = {
  getContactList(params) {
    return http({
      url: 'user/patient_data',
      params
    })
  },
  getContactDetail(id) {
    return http({
      url: `user/patient_data/${id}`
    })
  },
  addContact(data) {
    return http({
      method: 'post',
      url: 'user/patient_data',
      data
    })
  },
  editContact(data, id) {
    return http({
      method: 'put',
      url: `user/patient_data/${id}`,
      data
    })
  },
  deleteContact(id) {
    return http({
      method: 'delete',
      url: `user/patient_data/${id}`
    })
  }
}

export default frequent_contact
